import React from "react";
import { Container, Row, Button } from "react-bootstrap";
import RecipeShared from '../Shared/recipe-shared';

import RecipeList from "../../recipes-list";

function HomeRecipes() {
  return (
    <section className="home-section text-center" id="home-recipes">
      <h2 className="home-subheading recipe-subheading">RECENT</h2>
      <Container>
        <Row>
          {RecipeList.filter(element => element.id < 4).map((element) => {
            return (
              <RecipeShared
                id={element.id}
                key={element.id}
                imageLink={element.imageLink}
                title={element.title}
                colSize={4}
                xsSize={12}
                color="white"
              />
            );
          })}
        </Row>
      </Container>
      <Button size="lg" className="home-recipes-btn" href="/recipes">
        View All Recipes
      </Button>
    </section>
  );
}

export default HomeRecipes;
